import styled, { css } from 'styled-components';
import { EXTRA_LARGE_VIEWPORT } from 'modules/theme/config';

interface IPlateProps {
  $borderless?: boolean;
}

const BorderlessPlateStyles = css`
  box-shadow: none;
  margin-top: 0;
  margin-bottom: 0;
  padding-top: 0;
  padding-bottom: 0;

  @media (max-width: ${EXTRA_LARGE_VIEWPORT}px) {
    padding-top: 0;
    padding-bottom: 0;
  }
`;

export const Plate = styled.div<IPlateProps>`
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: ${({ theme }) => theme.shadows.base};
  border-radius: 24px;
  padding: 32px;

  @media (max-width: ${EXTRA_LARGE_VIEWPORT}px) {
    padding: 16px;
  }

  ${({ $borderless }) => $borderless
    ? BorderlessPlateStyles
    : null}
`;

export default Plate;
